import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export const DefaultDetails = ({ deviation , className , contentClassName  })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-block'],
        "data-hook": BiDataHook.DEVIATION_META
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        showTitle: true
    })), isExtendedLoaded && /*#__PURE__*/ React.createElement(ExtendedDetails, {
        deviation: deviation
    }));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
